module.exports = __webpack_public_path__ + "sansg/img/ln2.ee3cc878.png";